import FilterParameter from '~/utils/FilterParameter/FilterParameter';
import FilterParameterDescription from '~/utils/FilterParameter/FilterParameterDescription';

import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerSearch(
	filterParameters: FilterParameter<string | string[]>[],
	availableParameters: FilterParameterDescription<string | string[]>[],
	sort: string | null,
	order: string | null
) {
	const filterParametersMap: { [key: string]: string | string[] | null } = {};
	availableParameters.forEach((parameter) => (filterParametersMap[parameter.name] = null));
	filterParameters.forEach((parameter) => (filterParametersMap[parameter.name] = parameter.value));

	logGoogleTagManagerEvent({
		event: 'cogvio.search',
		search: {
			filterParameters: filterParametersMap,
			sort,
			order,
		},
	});
}
